import React, {useState} from 'react';
import {injectIntl} from 'react-intl';
import Icon from '@Components/Icon';

const Profile = ({intl, profile, keyword, itemOrder}) => {
  const itemsPerPage = process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE;
  const pageId = itemOrder / itemsPerPage + 1;
  // eslint-disable-next-line max-len
  const profileUrl = `/find-employees/request-this-employee/?talentId=${profile.talentId}&talentSource=${profile.sourceSystem}&talentLoc=${profile.city}, ${profile.state}&keyword=${keyword}`;
  const ToggleLinkContent = ({iconName, text}) => {
    return (
      <>
        <span>{text}</span>
        <span className="icon icon--inline ml-xs">
          <Icon type={iconName}/>
        </span>
      </>
    );
  };
  const renderSkills = () => {
    let skillsLess = [];
    let skillsMore = [];
    const size = profile.skills.length;
    const sizeLess = size > 9 ? 9 : size;
    const [showMore, setShowMore] = useState(false);
    if (size) {
      skillsLess = profile.skills.slice(0, sizeLess).map((skill, index) => {
        return (
          <div key={index} className="badge badge--l bg-brand--blue">{skill}</div>
        );
      });
    }

    if (sizeLess !== size) {
      skillsMore = profile.skills.slice(sizeLess, size).map((skill, index) => {
        return (
          <div key={index} className="badge badge--l bg-brand--blue">{skill}</div>
        );
      });
    }

    return (
      <>
        <div className="text-brand-secondary-tint-60 mb-xs">{intl.formatMessage({id: 'Profile.SkillSetTitle'})}</div>
        <div className="element-group">
          {skillsLess}
          {showMore && (
            <>
              {skillsMore}
              <div className="flex-full pt-s">
                <div className="text-brand-secondary-tint-60 mb-xs">{intl.formatMessage({id: 'Profile.TalentIDTitle'})}</div>
                <div>{profile.talentId}</div>
              </div>
            </>
          )}
        </div>
        <button className="toggle-show p-xs mt-xs flex items-center" onClick={() => setShowMore(!showMore)}>
          {showMore ?
            <ToggleLinkContent iconName='chevron-up' text={intl.formatMessage({id: 'Profile.ShowLess'})}/> :
            <ToggleLinkContent iconName='chevron-down' text={intl.formatMessage({id: 'Profile.ShowMore'})}/>}
        </button>
      </>
    );
  };
  return (
    <>
      {(itemOrder % itemsPerPage == 0) &&
      <div
        className="section-separator section-separator--border"
        hidden={itemOrder <= 1}
        id={`page-${pageId}`}>
        <span>{intl.formatMessage({id: 'Profile.PageLabel'})}{pageId}</span>
      </div>}
      <li className="cards__item" data-rs-card="">
        <div className="cards__header">
          <div className="cards__logo-title-container">
            <h3 className="cards__title">
              <a className="cards__link" href={profileUrl}>
                {profile.jobTitle}
                <span className="make-entire-card-clickable" />
              </a>
            </h3>
          </div>
        </div>
        <div className="profile-meta">
          <a href={profileUrl} className="button button--filled button--m button--request-employee">
            {intl.formatMessage({id: 'Profile.RequestEmployeeButton'})}
          </a>
          <ul className="cards__meta">
            <li className="cards__meta-item">
              <span className="icon icon--inline">
                <Icon type="marker"/>
              </span>
              {`${profile.city}, ${profile.state}`}
            </li>
            <li className="cards__meta-item">
              <span className="icon icon--inline">
                <Icon type="dashboard"/>
              </span>
              {profile.experienceLevel}
            </li>
          </ul>
          <a href={profileUrl} className="button button--filled button--m button--request-employee-short">
            {intl.formatMessage({id: 'Profile.RequestEmployeeButton.Short'})}
          </a>
        </div>
        <div className="cards__badges pt-m">{renderSkills()}</div>
      </li>
    </>
  );
};

export default injectIntl(Profile);
